module.exports = __webpack_public_path__ + "static/media/2012.0f2b4620.svg";